import { render } from "./HomeLearn.vue?vue&type=template&id=16f91b96&scoped=true"
import script from "./HomeLearn.vue?vue&type=script&lang=js"
export * from "./HomeLearn.vue?vue&type=script&lang=js"

import "./HomeLearn.vue?vue&type=style&index=0&id=16f91b96&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f91b96"]])

export default __exports__